import { BarChart3, Layers, Activity, Search, PieChart, Clock } from "lucide-react";
import ProductPageLayout from "@/components/ProductPageLayout";

export default function MarketIntelligence() {
  return (
    <ProductPageLayout
      meta={{
        title: "Market Intelligence — Quantitative Market Analytics | Adviserz",
        description:
          "Structured market intelligence, market-structure analysis and quantitative stock screening & market analytics. Informational and analytical only — not investment advice.",
        canonical: "https://adviserz.in/market-intelligence",
      }}
      overline="Platform · Market Intelligence"
      title="Market intelligence for"
      accent="informed decision-making."
      lede="Market intelligence at Adviserz means structured, data-driven context: what the data shows, how market structure is evolving, and which measurable factors are changing. The output is analytical information for your own research process — not a recommendation to act."
      capabilities={[
        { icon: BarChart3, t: "Market Data Visualisation", d: "Interactive views of price, volume, breadth and participation data designed to make structural change visible rather than hidden in tables." },
        { icon: Search, t: "Quantitative Screening & Analytics", d: "Rule-based and statistical screening across measurable attributes — liquidity, volatility, momentum statistics and fundamental data fields." },
        { icon: Layers, t: "Market Structure Analysis", d: "Analysis of trend structure, ranges, participation and regime characteristics across indices and instruments." },
        { icon: Activity, t: "Quantitative Market Signals & Analytics", d: "Model-derived quantitative indicators presented as analytical measurements with their historical context and limitations." },
        { icon: PieChart, t: "Sector & Breadth Analytics", d: "Cross-sectional analytics on sector dispersion, relative strength statistics and market participation." },
        { icon: Clock, t: "Historical Context", d: "Comparison of current measurements with historical distributions so users can judge whether conditions are ordinary or unusual." },
      ]}
      approach={[
        { t: "Measure", d: "Quantify market conditions using transparent, reproducible statistical definitions." },
        { t: "Contextualise", d: "Place each measurement within its historical distribution so it can be interpreted rather than simply consumed." },
        { t: "Visualise", d: "Present analytics through clear data visualisation designed for interpretation, with assumptions stated." },
        { t: "Explain", d: "Document what each analytic does and does not capture, including data limitations." },
      ]}
      notWhatWeDo={[
        "No \"best stocks to buy\" lists",
        "No target or stop-loss levels",
        "No buy/sell calls",
        "No personalised portfolio advice",
        "No assured or risk-free outcomes",
        "No solicitation to transact in securities",
      ]}
    />
  );
}
